<main>
    <form [formGroup]="formGroup" (ngSubmit)="onSave()">
        <mat-card>
            <mat-card-header>User Profile</mat-card-header>
            <mat-card-content>
                <mat-form-field>
                    <mat-label>User ID</mat-label>
                    <input matInput [readonly]="true" formControlName="user_id" />
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Description</mat-label>
                    <textarea matInput placeholder="About you" formControlName="user_desciption"></textarea>
                    <mat-hint>You may include whatever you wish here, but remember that it is publically viewable.</mat-hint>
                </mat-form-field>
            </mat-card-content>
            <mat-card-actions class="moveright">
                <button mat-raised-button color="primary" type="submit" [disabled]="!formGroup.dirty">Save</button>
            </mat-card-actions>
        </mat-card>
    </form>
    <mat-card>
        <mat-card-header>Your Projects</mat-card-header>
        <mat-card-content>
            <mat-action-list>
                @for (project of syncService.user$.value?.projects; track project.project_id) {
                  <mat-list-item [routerLink]="['/workspace', project.project_id]">
                    <h3 matListItemTitle>{{project.title}}</h3>
                    <p matListItemLine>
                      {{project.description | marked | async}}
                    </p>
                  </mat-list-item>
                }
              </mat-action-list>
        </mat-card-content>
    </mat-card>
</main>